import React from 'react'
import { Grant } from '@meprism/shared/src/redux/product/ProductTypes'
import { Link } from 'react-router-dom'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import DashboardCard from './DashboardStatsCard'

interface RemovalProgressCardProps {
  removing: number
  removed: number
  grant: Grant | undefined
}

const RemovalProgressCard: React.FC<RemovalProgressCardProps> = ({ removing, removed, grant }) => {
  const totalRecords = removed + removing
  const progress = totalRecords > 0 ? (removed / totalRecords) * 100 : 0

  const lockIcon = !grant ? (
    <Link to="/subscription" style={{ marginLeft: 'auto' }}>
      <LockOutlinedIcon sx={{ mb: -2, fontSize: 20, color: '#7459D9' }} />
    </Link>
  ) : undefined

  return (
    <DashboardCard
      heading="Removal Progress"
      tooltipText="This section shows how your personal data profiles are being removed from various data brokers and how many have been successfully removed"
      mainStatValue={removed}
      mainStatLabel="Profiles Removed"
      progress={progress}
      leftStat={{ label: 'Removals in Progress', value: removing, barColor: '#7459D9' }}
      rightStat={{ label: 'Profiles Removed', value: removed, barColor: '#7459D980' }}
      locked={!grant}
      headerExtra={lockIcon}
    />
  )
}

export default RemovalProgressCard
